module.exports = __webpack_public_path__ + "static/SignApp-e074db4913356532b38ff0b4e63a6c4b.png";